(function () {
  function initContactUsCardDrawer() {
    const trigger = document.getElementById('ContactUsCardTrigger');
    const drawer = document.getElementById('ContactUsCardDrawer');
    const overlay = document.getElementById('ContactUsCardOverlay');
    const closeBtn = document.getElementById('ContactUsCardClose');
    const form = document.getElementById('ContactUsCardContactForm');
    const mainView = document.getElementById('ContactUsCardMainView');
    const successState = document.getElementById('ContactUsCardSuccessState');

    if (!trigger || !drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      trigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-open');
      trigger.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      sessionStorage.removeItem('contact_posted');
      sessionStorage.removeItem('submitted_form_source');
    }

    trigger.addEventListener('click', openDrawer);
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeDrawer();
      }
    });

    // Do NOT open drawer or show thank-you view while user is solving captcha challenge
    if (window.location.pathname.indexOf('/challenge') !== -1 || window.location.pathname.indexOf('/captcha') !== -1) {
      return;
    }

    // Handle post-submission drawer display
    const search = window.location.search || '';
    const hash = window.location.hash || '';
    const isPosted = search.indexOf('contact_posted=true') !== -1 ||
      hash.indexOf('contact_posted=true') !== -1 ||
      sessionStorage.getItem('contact_posted') === 'true';
    const formSource = sessionStorage.getItem('submitted_form_source') || '';

    const isCardForm = formSource === 'side-button' ||
      hash.indexOf('ContactUsCard') !== -1 ||
      search.indexOf('ContactUsCard') !== -1 ||
      search.indexOf('thank-you=contact-us-thank-you') !== -1;

    if (isPosted && isCardForm) {
      openDrawer();
      if (mainView) mainView.style.display = 'none';
      if (successState) successState.style.display = 'block';

      // Clear session storage IMMEDIATELY so it never pops up again on other pages
      sessionStorage.removeItem('contact_posted');
      sessionStorage.removeItem('submitted_form_source');

      try {
        window.history.replaceState({ contactPosted: true }, '', window.location.pathname + '?thank-you=contact-us-thank-you');
      } catch (e) { }

      if (typeof window.fireThankYouConfetti === 'function') {
        setTimeout(window.fireThankYouConfetti, 200);
      }

      // Auto-hide / auto-close drawer after 6 seconds
      setTimeout(function () {
        closeDrawer();
      }, 6000);
    }

    if (form) {
      form.addEventListener('submit', function () {
        sessionStorage.setItem('contact_posted', 'true');
        sessionStorage.setItem('submitted_form_source', 'side-button');
      });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initContactUsCardDrawer);
  } else {
    initContactUsCardDrawer();
  }
})();
